import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbDatepickerModule, NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import moment from 'moment';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { AdditionOfManpowerService } from '../../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { ViewofReductonConfirmationListComponent } from '../../viewof-reducton-confirmation-list/viewof-reducton-confirmation-list.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ActivatedRoute, Router } from '@angular/router';
import { elements } from 'chart.js';
import { Subject } from 'rxjs';
import { DesignationWiseSummaryComponent } from '../../designation-wise-summary/designation-wise-summary.component';
import { AdditionReductionWarningComponent } from '../../AdditionReductionWarning/addition-reduction-warning/addition-reduction-warning.component';

@Component({
  selector: 'app-addition-of-manpower-new',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, NgbDropdownModule, NgSelectModule, NgbDatepickerModule, DataTablesModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './addition-of-manpower-new.component.html',
  styleUrl: './addition-of-manpower-new.component.scss'
})
export class AdditionOfManpowerNewComponent {
  isDisabled: boolean = false;
  User: any = null;

  Branchs: any[] = [];
  Clients: any[] = [];
  Sites: any[] = [];
  Designations: any[] = [];
  Dutys: any[] = [];
  Shifts: any[] = [];

  AddManpowers: any[] = [];

  Filter = {
    WorkOrderDate: null as any,
    WorkOrderNumber: null,
    EntryNo: null as any,
    AllocationType: "A",
    BranchID: null as any,
    ClientID: null as any,
    SiteID: null as any,
    DesignationID: null,
    DutyID: null,
    ShiftID: null,
    AllocationTypes: 'Addition',
    TotalManpower: 0,
    NoOfManpower: null,
    FromDate: null as any,
    ToDate: null as any,
    EffectiveDate: null as any,
    Remark: null,
    Filename: null as any,
    FileURL: null as any,
    EditIndex: null as any,
    ESS_ShiftWiseManpowerMasterId: 0,
    TodayDate: null,
    TotalAllotedManpower: 0,
    IsAutoReduction: false,
    FromPageType: null
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private comboload: ComboService,
    private toast: ToastService,
    private dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    protected common: CommonService,
    private session: SessionService,
    private utility: UtilityService,
    private siteadditionreduction: AdditionOfManpowerService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.User = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.ESS_ShiftWiseManpowerMasterId = parseInt(params['id']));
    this.route.params.subscribe(params => this.Filter.FromPageType = params['type']);
    if (this.Filter.ESS_ShiftWiseManpowerMasterId == 0 && this.Filter.FromPageType == 's') {
      this.route.params.subscribe(params => this.Filter.BranchID = parseInt(params['bid']));
      this.route.params.subscribe(params => this.Filter.ClientID = parseInt(params['cid']));
      this.route.params.subscribe(params => this.Filter.SiteID = parseInt(params['sid']));
    } else if (this.Filter.FromPageType == 'o' || this.Filter.FromPageType == 'p') {
      this.Filter.AllocationType = 'O';
      this.Filter.AllocationTypes = 'Opening';
    }
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('AllDesignation');
    this.ComboLoad('AllDuty');
    this.ComboLoad('Shift');
    if (this.Filter.ESS_ShiftWiseManpowerMasterId == 0) {
      this.ComboLoad('Branch', false);
      if (this.Filter.FromPageType == 's') {
        this.ComboLoad('Client', false);
        this.ComboLoad('Site', false);
        this.SelectDate('RegistrationDate', null, null);
      }
    } else {
      this.getData("View");
      this.getData("S");
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.Filter.NoOfManpower != null && this.Filter.NoOfManpower > 0 && this.Filter.NoOfManpower != '') {
        if ((this.Filter.ToDate == null || this.Filter.ToDate == '') || (moment(this.dateFormate.format(this.Filter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.Filter.FromDate), 'DD MMM YYYY')))) {
          if (this.Filter.ToDate == null || this.Filter.ToDate == '') {
            this.Filter.EffectiveDate = null;
          }
          this.add();
          form.submitted = false;
        } else {
          this.toast.show({ message: 'To Date must be greater than From Date!', type: toastTypeEnum.warning });
          this.Filter.ToDate = null;
          this.Filter.EffectiveDate = null;
        }
      } else {
        this.toast.show({ message: 'Please enter no of manpower', type: toastTypeEnum.warning });
      }
    } else {
      form.submitted = true;
    }
  }

  ComboLoad(Combotype: String, IsClear = true) {
    this.isDisabled = true

    if (Combotype == 'Branch' && IsClear) {
      this.Branchs = [];
      this.Clients = [];
      this.Sites = [];

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype == 'Client' && IsClear) {
      this.Clients = [];
      this.Sites = [];
      this.AddManpowers = [];

      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
    } else if (Combotype == 'Site' && IsClear) {
      this.Sites = [];
      this.AddManpowers = [];

      this.Filter.SiteID = null;
    } else if (Combotype == 'Designation') {

      this.Filter.DesignationID = null;
      this.Filter.DutyID = null;
      this.Filter.ShiftID = null;
    } else if (Combotype == 'Duty') {
      this.Dutys = [];
      this.Shifts = [];

      this.Filter.DutyID = null;
      this.Filter.ShiftID = null;
    } else if (Combotype == 'Shift') {
      this.Shifts = [];

      this.Filter.ShiftID = null;
    }

    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Branch' || Combotype == 'Client' || Combotype == 'Site') ? this.Filter.BranchID : 0,
      'ClientId': (Combotype == 'Client' || Combotype == 'Site') ? this.Filter.ClientID : 0,
      'SiteId': (Combotype == 'Site') ? this.Filter.SiteID : 0,
      'DesignationId': 0,
      'EmpType': ''
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad.length >= 0) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          } else if (Combotype == 'AllDesignation') {
            this.Designations = response.ComboLoad;
          } else if (Combotype == 'AllDuty') {
            this.Dutys = response.ComboLoad;
          } else if (Combotype == 'Shift') {
            this.Shifts = response.ComboLoad;
          }
        }
        else {
          this.toast.show({ message: 'No Data is there in Load', type: toastTypeEnum.warning });
        }
        this.isDisabled = false
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }

  add() {
    this.isDisabled = true;
    if (!this.Filter.IsAutoReduction && this.Filter.AllocationType != 'O') {
      if (this.AddManpowers.findIndex(e => e.DesignationId == this.Filter.DesignationID &&
        e.DutyId == this.Filter.DutyID &&
        e.ShiftId == this.Filter.ShiftID &&
        moment(this.dateFormate.format(this.Filter.FromDate)).isSame(e.FromDate)
      ) == -1 || this.AddManpowers.findIndex(e => e.DesignationId == this.Filter.DesignationID &&
        e.DutyId == this.Filter.DutyID &&
        e.ShiftId == this.Filter.ShiftID &&
        moment(this.dateFormate.format(this.Filter.FromDate)).isSame(e.FromDate)
      ) == this.Filter.EditIndex) {
        if (this.Filter.EditIndex != null) {
          this.AddManpowers[this.Filter.EditIndex].BranchId = this.Filter.BranchID,
            this.AddManpowers[this.Filter.EditIndex].BranchName = this.Branchs.find(e => e.BranchMasterID === this.Filter.BranchID).BranchName,
            this.AddManpowers[this.Filter.EditIndex].ClientId = this.Filter.ClientID,
            this.AddManpowers[this.Filter.EditIndex].ClientGroupName = this.Clients.find(e => e.ClientGroupMasterID === this.Filter.ClientID).ClientGroupName,
            this.AddManpowers[this.Filter.EditIndex].SiteId = this.Filter.SiteID,
            this.AddManpowers[this.Filter.EditIndex].SiteName = this.Sites.find(e => e.SiteMasterID === this.Filter.SiteID).SiteName,
            this.AddManpowers[this.Filter.EditIndex].DesignationId = this.Filter.DesignationID,
            this.AddManpowers[this.Filter.EditIndex].DesignationName = this.Designations.find(e => e.DesignationMasterID === this.Filter.DesignationID).DesignationName,
            this.AddManpowers[this.Filter.EditIndex].DutyName = this.Dutys.find(e => e.DutyMasterID === this.Filter.DutyID).DutyName,
            this.AddManpowers[this.Filter.EditIndex].ShiftId = this.Filter.ShiftID,
            this.AddManpowers[this.Filter.EditIndex].ShiftTitle = this.Shifts.find(e => e.ShiftMasterID === this.Filter.ShiftID).ShiftTitle,
            this.AddManpowers[this.Filter.EditIndex].FromDate = this.dateFormate.format(this.Filter.FromDate),
            this.AddManpowers[this.Filter.EditIndex].ToDate = this.dateFormate.format(this.Filter.ToDate),
            this.AddManpowers[this.Filter.EditIndex].NoOfPerson = this.Filter.NoOfManpower,
            this.AddManpowers[this.Filter.EditIndex].Remarks = this.Filter.Remark,
            this.AddManpowers[this.Filter.EditIndex].ReductionEffectiveAfter = this.dateFormate.format(this.Filter.EffectiveDate)
        } else {
          this.AddManpowers.push({
            BranchId: this.Filter.BranchID,
            BranchName: this.Branchs.find(e => e.BranchMasterID === this.Filter.BranchID).BranchName,
            ClientId: this.Filter.ClientID,
            ClientGroupName: this.Clients.find(e => e.ClientGroupMasterID === this.Filter.ClientID).ClientGroupName,
            SiteId: this.Filter.SiteID,
            SiteName: this.Sites.find(e => e.SiteMasterID === this.Filter.SiteID).SiteName,
            DesignationId: this.Filter.DesignationID,
            DesignationName: this.Designations.find(e => e.DesignationMasterID === this.Filter.DesignationID).DesignationName,
            DutyId: this.Filter.DutyID,
            DutyName: this.Dutys.find(e => e.DutyMasterID === this.Filter.DutyID).DutyName,
            ShiftId: this.Filter.ShiftID,
            ShiftTitle: this.Shifts.find(e => e.ShiftMasterID === this.Filter.ShiftID).ShiftTitle,
            FromDate: this.dateFormate.format(this.Filter.FromDate),
            ToDate: this.dateFormate.format(this.Filter.ToDate),
            NoOfPerson: this.Filter.NoOfManpower,
            RefESS_ShiftWiseManpowerDetailsId: 0,
            Remarks: this.Filter.Remark,
            ESS_ShiftWiseManpowerDetailsId: 0,
            ReductionEffectiveAfter: this.dateFormate.format(this.Filter.EffectiveDate),

          });
        }
        this.clear();
        this.calculateTotalAllotedManpower();
        this.isDisabled = false;
        this.toast.show({ message: 'Manpower Added in the List!', type: toastTypeEnum.success });
      } else {
        this.toast.show({ message: "Item already exist", type: toastTypeEnum.warning });
        this.isDisabled = false;
      }
    }
  }

  onEditClick(index: number): void {
    if ((this.AddManpowers[index].IsMonthLocked == 0 || this.AddManpowers[index].EntryNo == undefined || this.AddManpowers[index].EntryNo == null) && !this.Filter.IsAutoReduction) {
      this.Filter.DesignationID = this.AddManpowers[index].DesignationId;
      this.Filter.DutyID = this.AddManpowers[index].DutyId;
      this.Filter.ShiftID = this.AddManpowers[index].ShiftId;
      this.Filter.FromDate = this.dateFormate.parse(this.AddManpowers[index].FromDate);
      this.Filter.ToDate = (this.AddManpowers[index].ToDate == '' || this.AddManpowers[index].ToDate == null) ? null : this.dateFormate.parse(this.AddManpowers[index].ToDate);
      this.Filter.EffectiveDate = this.dateFormate.parse(this.AddManpowers[index].ReductionEffectiveAfter);
      this.Filter.NoOfManpower = this.AddManpowers[index].NoOfPerson;
      this.Filter.Remark = this.AddManpowers[index].Remarks;
      this.Filter.EditIndex = index;
      this.Filter.EntryNo = this.AddManpowers[index].EntryNo;
    }
  }

  deleteRow(index: number): void {
    if ((this.AddManpowers[index].IsMonthLocked == 0 || this.AddManpowers[index].EntryNo == undefined) && !this.Filter.IsAutoReduction) {
      if (this.Filter.EditIndex != index) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'Are you Sure want to Delete?'
        modalRef.result.then((result: any) => {
          if (result) {
            this.AddManpowers.splice(index, 1);
            this.calculateTotalAllotedManpower();
          }
        }).catch(() => { });
      } else {
        this.toast.show({ message: 'Delete not allowed for edit entry', type: toastTypeEnum.warning });
      }
    }
  }

  SetEffectiveDate() {
    if (this.Filter.ToDate != null && this.Filter.ToDate != '') {
      this.Filter.EffectiveDate = moment(this.dateFormate.format(this.Filter.ToDate));
      this.Filter.EffectiveDate = moment(this.Filter.EffectiveDate.add({ day: 1 }));
      this.Filter.EffectiveDate = this.dateFormate.parse(this.Filter.EffectiveDate.format("DD MMM YYYY"))
    } else {
      this.Filter.EffectiveDate = null;
    }
  }

  clear() {
    this.Filter.EditIndex = null;
    this.Filter.NoOfManpower = null;
    this.Filter.DesignationID = null;
    this.Filter.DutyID = null;
    this.Filter.ShiftID = null;
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.EffectiveDate = null;
    this.Filter.Remark = null;
    if (this.Filter.ESS_ShiftWiseManpowerMasterId == 0) {
      this.Filter.EntryNo = null;
    }
    //this.Filter.t = null
  }

  onFileSelected(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.uploadToFTP(input.files[0]);
    }
  }

  uploadToFTP(file: File) {
    this.isDisabled = true;
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({ 'DomainName': this.User.Domain, 'folder': 'AdditonOfManpower', 'CompanyCode': this.User.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
        if (response.FileName != "") {
          // this.toast.show({ message: 'File uploaded successfully', type: toastTypeEnum.success });
          this.Filter.Filename = response.FileName;
          this.Filter.FileURL = response.Url;
        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }

  removeFile() {
    this.Filter.Filename = null;
    this.Filter.FileURL = null;
    const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  viewFile() {
    window.open(this.Filter.FileURL, '_blank');
  }

  save() {
    if ((this.Filter.ESS_ShiftWiseManpowerMasterId == 0 && this.common.PageRight.IsAdd) || (this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && this.common.PageRight.IsEdit)) {
      if (this.Filter.ESS_ShiftWiseManpowerMasterId == 0 || (this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && !this.Filter.IsAutoReduction && this.Filter.AllocationType != 'O')) {
        if (this.Filter.EditIndex != null) {
          this.toast.show({ message: 'Please update entry before save', type: toastTypeEnum.warning });
        } else if ((this.Filter.WorkOrderNumber != null && this.Filter.WorkOrderNumber != '') && this.Filter.WorkOrderDate == null) {
          this.toast.show({ message: 'Please select Work Order Date', type: toastTypeEnum.warning });
        } else {
          if (this.Filter.BranchID == 0 || this.Filter.BranchID == null) {
            this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
          } else if (this.Filter.ClientID == 0 || this.Filter.ClientID == null) {
            this.toast.show({ message: 'Please select Client!', type: toastTypeEnum.warning });
          } else if (this.Filter.SiteID == 0 || this.Filter.SiteID == null) {
            this.toast.show({ message: 'Please select Site!', type: toastTypeEnum.warning });
          } else if (this.Filter.ESS_ShiftWiseManpowerMasterId == 0 && this.AddManpowers.length == 0) {
            this.toast.show({ message: 'Please enter atleast one manpower!', type: toastTypeEnum.warning });
          } else {
            const modalRef = this.modalService.open(ConfirmationComponent, {
              size: 'md',
              backdrop: 'static',
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = 'Are you Sure want to save?'
            modalRef.result.then((result: any) => {
              if (result) {
                this.CheckManpowerValidation('WO');
              }
            }).catch(() => { });
          }
        }
      }
    }
  }

  CheckManpowerValidation(SelecType: string) {
    this.isDisabled = true;
    const manpower = this.AddManpowers.length > 0 ? this.AddManpowers.map(element => {
      return {
        DesignationId: element.DesignationId,
        DutyId: element.DutyId,
        ShiftId: element.ShiftId,
        FromDate: element.FromDate,
        ToDate: element.ToDate,
        NoOfPerson: element.NoOfPerson,
        RefESS_ShiftWiseManpowerDetailsId: element.RefESS_ShiftWiseManpowerDetailsId,
        Remarks: element.Remarks,
        ESS_ShiftWiseManpowerDetailsId: element.ESS_ShiftWiseManpowerDetailsId
      };
    }) : [];
    const validation = {
      SelectType: SelecType,
      ESS_ShiftWiseManpowerMasterId: this.Filter.ESS_ShiftWiseManpowerMasterId,
      ESS_ShiftWiseManpowerDetails: manpower,
      AllocationType: this.Filter.AllocationType,
      WoNo: this.Filter.WorkOrderNumber,
      SiteId: this.Filter.SiteID,
    };

    this.siteadditionreduction.ESS_SiteManpowerValidation(validation).subscribe({
      next: (response) => {
        if (response.Table[0].Column1 == '01') {
          if (this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && SelecType == 'WO') {
            this.CheckManpowerValidation('U');
          } else {
            this.Insertupdate();
          }
        } else {
          if (SelecType == 'WO') {
            const modalRef = this.modalService.open(ViewofReductonConfirmationListComponent, {
              size: (response.Table2 != undefined && response.Table2.length > 0) ? 'xl' : 'lg',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });

            if (response.Table2 != undefined && response.Table2.length > 0) {
              modalRef.componentInstance.Dataa = response.Table2;
            }
            modalRef.componentInstance.Message = response.Table1[0].Column1;
            modalRef.result.then((result: any) => {
              if (result) {
                if (this.Filter.ESS_ShiftWiseManpowerMasterId > 0) {
                  this.CheckManpowerValidation('U');
                } else {
                  this.Insertupdate();
                }
              }
            }).catch(() => { });
          } else if (this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && SelecType == 'U') {
            const modalRef = this.modalService.open(ViewofReductonConfirmationListComponent, {
              size: (response.Table2 != undefined && response.Table2.length > 0) ? 'xl' : 'lg',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });

            if (response.Table2 != undefined && response.Table2.length > 0) {
              modalRef.componentInstance.Dataa = response.Table2;
            }
            modalRef.componentInstance.Message = response.Table1[0].Column1;
            modalRef.result.then((result: any) => {
              if (result) {
                this.Insertupdate();
              }
            }).catch(() => { });
          } else {
            this.Insertupdate();
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Insertupdate() {
    this.isDisabled = true
    const manpower = this.AddManpowers.map(element => {
      return {
        DesignationId: element.DesignationId,
        DutyId: element.DutyId,
        ShiftId: element.ShiftId,
        FromDate: element.FromDate,
        ToDate: element.ToDate,
        NoOfPerson: element.NoOfPerson,
        RefESS_ShiftWiseManpowerDetailsId: element.RefESS_ShiftWiseManpowerDetailsId,
        Remarks: element.Remarks,
        ESS_ShiftWiseManpowerDetailsId: element.ESS_ShiftWiseManpowerDetailsId
      };
    });
    const additionData = {
      SelectType: this.Filter.ESS_ShiftWiseManpowerMasterId > 0 ? 'U' : 'I',
      ESS_ShiftWiseManpowerMasterId: this.Filter.ESS_ShiftWiseManpowerMasterId,
      ESS_ShiftWiseManpowerDetails: manpower,
      WoNo: this.Filter.WorkOrderNumber,
      WoDate: this.dateFormate.format(this.Filter.WorkOrderDate),
      SiteId: this.Filter.SiteID,
      UserID: this.User.UserId,
      AllocationType: 'A',
      Attachment: this.Filter.Filename
    };

    this.siteadditionreduction.ESS_SiteManpowerAdditionReduction(additionData).subscribe({
      next: (response) => {
        if (response.Error_Code == '365' || response.Error_Code == '368') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.Back();
            }
          });
        }
        else {
          if (response.SiteInfo && response.SiteInfo.length > 0) {
            const modalRef = this.modalService.open(AdditionReductionWarningComponent, {
              size: 'xl',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Dataa = response.SiteInfo;
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {}).catch(() => { });
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  getData(Type: String) {
    this.isDisabled = true;
    const data = {
      SelectType: Type,
      ESS_ShiftWiseManpowerMasterId: this.Filter.ESS_ShiftWiseManpowerMasterId,
      AllocationType: this.Filter.AllocationType,
      WoNo: this.Filter.WorkOrderNumber,
      SiteId: this.Filter.SiteID,
      DesignationId: this.Filter.DesignationID,
      DutyId: this.Filter.DutyID,
      ShiftId: this.Filter.ShiftID,
      AsOnDate: null
    }

    this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet(data).subscribe({
      next: (response) => {
        if (Type == 'View') {
          if (response.Table.length > 0) {
            this.Filter.WorkOrderDate = (response.Table[0].WODate != null || response.Table[0].WODate != '') ? this.dateFormate.parse(response.Table[0].WODate) : null;
            this.Filter.WorkOrderNumber = response.Table[0].WONo;
            this.Filter.EntryNo = response.Table[0].EntryNo;
            this.Filter.BranchID = response.Table[0].BranchId;
            this.Filter.ClientID = response.Table[0].ClientId;
            this.Filter.SiteID = response.Table[0].SiteId;
            this.Filter.IsAutoReduction = response.Table[0].IsAutoReduction ?? false;
            this.Branchs = [{ BranchMasterID: response.Table[0].BranchId, BranchName: response.Table[0].BranchName }];
            this.Clients = [({ ClientGroupMasterID: response.Table[0].ClientId, ClientGroupName: response.Table[0].ClientGroupName })];
            this.Sites = [({ SiteMasterID: response.Table[0].SiteId, SiteName: response.Table[0].SiteName })];
            this.SelectDate('RegistrationDate', null, null);
          }
        } else if (Type == "S") {
          if (response.Table.length > 0) {
            this.AddManpowers = response.Table;
            this.calculateTotalAllotedManpower();
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SplitName() {
    return this.Filter.Filename.split("/")[1];
  }

  Count() {
    this.Filter.TotalManpower = 0
    this.isDisabled = true
    this.siteadditionreduction.ESS_SiteManpowerSummary({
      SelectType: 'Count',
      RegionId: '',
      BranchId: this.Filter.BranchID,
      ZoneId: '',
      ClientId: this.Filter.ClientID,
      SiteId: this.Filter.SiteID,
      SupervisorId: '',
      AsOnDate: this.Filter.TodayDate
    }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.Filter.TotalManpower = response.Table[0].NoOfPerson;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    if (this.Filter.TodayDate == null) {
      return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
        next: (response) => {
          if (SelectType == 'RegistrationDate') {
            this.Filter.TodayDate = response.Table[0].RegistrationDate;
            this.Count();
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.Count();
      return;
    }
  }

  calculateTotalAllotedManpower() {
    this.Filter.TotalAllotedManpower = this.AddManpowers.reduce((total, element) => {
      return total + parseInt(element.NoOfPerson);
    }, 0);
  }

  Back() {
    if (this.Filter.FromPageType == 'v' || this.Filter.FromPageType == 'o') {
      this.router.navigate(['master/ViewAllocateManpowerNew']);
    }
    else {
      this.router.navigate(['master/sitewisemanpowersummarynew']);
    }
  }

  OpenDesignationSummary() {
    if (!this.Filter.IsAutoReduction && this.Filter.AllocationType != 'O') {
      if (this.Filter.BranchID == null || this.Filter.BranchID == 0) {
        this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      } else if (this.Filter.ClientID == null || this.Filter.ClientID == 0) {
        this.toast.show({ message: 'Please select Client!', type: toastTypeEnum.warning });
      } else if (this.Filter.SiteID == null || this.Filter.SiteID == 0) {
        this.toast.show({ message: 'Please select Site!', type: toastTypeEnum.warning });
      } else {
        const data = {
          SelectType: 'D',
          RegionId: '',
          BranchId: this.Filter.BranchID,
          ZoneId: '',
          ClientId: this.Filter.ClientID,
          SiteId: this.Filter.SiteID,
          SupervisorId: '',
          AsOnDate: this.Filter.TodayDate
        }
        const modalRef = this.modalService.open(DesignationWiseSummaryComponent, {
          centered: true,
          backdrop: 'static',
          size: 'xl'
        });
        modalRef.componentInstance.InputData = data;
        modalRef.componentInstance.edit = false;
      }
    }
  }
}
